import { useEffect, useRef, useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Skeleton from "@mui/material/Skeleton";

const RenderLoading = () => {
  const [height, setHeight] = useState<number>(0);
  const divRef = useRef<HTMLDivElement | null>(null);

  const getCountSkeletons = () => {
    if (height) {
      let possibleCells = height / 75;

      return Math.floor(possibleCells);
    } else {
      return 11;
    }
  };

  const updateHeight = () => {
    if (divRef.current) {
      setHeight(divRef.current.offsetHeight);
    }
  };

  useEffect(() => {
    updateHeight();
    window.addEventListener("resize", updateHeight);

    return () => {
      window.removeEventListener("resize", updateHeight);
    };
  }, []);

  return (
    <div className="h-full flex flex-col">
      {/* Top Bar Skeleton*/}
      <div className="flex justify-between items-center pb-2 h-[10%]">
        <Skeleton variant="rectangular" width="30%" height={40} />
        <Skeleton variant="rectangular" width="15%" height={40} />
      </div>
      {/* Table Skeleton */}
      <div className="h-[90%]" ref={divRef}>
        <TableContainer
          sx={{
            overflow: "hidden",
            maxWidth: "100%",
            maxHeight: "100%",
          }}
        >
          <Table>
            <TableHead
              sx={{
                backgroundColor: "var(--color-table-header)",
                "& .MuiTableCell-head": {
                  backgroundColor: "var(--color-table-header)",
                },
              }}
            >
              <TableRow sx={{ height: "70px" }}>
                <TableCell>
                  <Skeleton width="30%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="40%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="60%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="70%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="90%" variant="rectangular" />
                </TableCell>
                <TableCell>
                  <Skeleton width="40%" variant="rectangular" />
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {Array.from({ length: getCountSkeletons() }).map((_, index) => (
                <TableRow
                  key={index}
                  sx={{
                    "&:last-child td, &:last-child th": { border: 0 },
                    height: "70px",
                  }}
                >
                  <TableCell>
                    <Skeleton width="30%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="40%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="60%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="70%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="90%" variant="rectangular" />
                  </TableCell>
                  <TableCell>
                    <Skeleton width="40%" variant="rectangular" />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </div>
  );
};

export default RenderLoading;
